import isEmpty from 'lodash/isEmpty';

export const setValueAsNumber = (value: unknown) =>
  isEmpty(value) ? null : Number(value);
